import React, { useContext } from 'react'
import { withTranslationCustom } from 'lib/i18next'
import ErrorMessageContent from './ErrorMessageContent'
import { DevErrorViewContext } from 'components/Errors/DevErrorView'

const DEV_TEST_DATA = [
    {
        fieldValue: 'Value',
        fieldName: 'Name',
        rowNumber: '1',
    },
    {
        fieldValue: 'Value',
        fieldName: 'Name',
        rowNumber: '2',
    }
]

const RefillEventCsvMessage = ({ t, appError }) => {
    let data = appError.data

    const devErrorContext = useContext(DevErrorViewContext)

    if (devErrorContext) {
        data = DEV_TEST_DATA
    }

    return (
        <ErrorMessageContent
            title={t('errors:omanettix.10060.title')}
            content={(
                <>
                    <p>
                        {t('errors:omanettix.10060.message')}
                    </p>
                    <ul>
                        {data.header && <li>CSV columns are not matching for import operation</li>}

                        {!data.header &&
                            data.map((dataRow, i) => {
                                return <li key={i}>Invalid value <b>{dataRow.fieldValue}</b> for field <b>{dataRow.fieldName}</b> at row <b>{dataRow.rowNumber}</b></li>
                            })}
                    </ul>
                </>
            )}
        />
    )
}

export default withTranslationCustom(['errors', 'vehicleSearch'])(RefillEventCsvMessage)
